<template>
  <div class="forget_page">
    <div class="forget_pwd" v-if="loginType == 2">
      <h3>忘记密码</h3>
      <!-- 表单 -->
      <el-form
        :model="forgetForm"
        :rules="forgetRules"
        ref="ruleForm"
        label-width="120px"
        class="forger_form"
        :hide-required-asterisk="true"
      >
        <el-form-item label="手机号 :" prop="phone" class="phoneClass">
          <el-input
            v-model="forgetForm.phone"
            type="number"
            placeholder="请输入手机号"
          ></el-input>
          <div class="noreg" v-if="(is_reg = false)">
            <img src="../../assets/images/登录界面/错误icon.png" alt="" />
            <span>{{ noRegText }}</span>
          </div>
        </el-form-item>
        <el-form-item
          class="v_code"
          label="短信验证码 :"
          prop="verificationCode"
        >
          <el-input
            v-model="forgetForm.verificationCode"
            class="code"
            placeholder="请输入验证码"
          ></el-input>
          <el-button type="primary" size="small" @click="sendCode">{{
            codeText
          }}</el-button>
        </el-form-item>
        <el-form-item label="新密码 :" prop="newPwd">
          <el-input
            type="password"
            v-model="forgetForm.newPwd"
            autocomplete="off"
            placeholder="请输入6-16位由数字/字母/字符组成的新密码"
            @input="accountInputs1"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码 :" prop="checkPwd">
          <el-input
            type="password"
            v-model="forgetForm.checkPwd"
            autocomplete="off"
            placeholder="请再次输入密码"
            @input="accountInputs2"
          ></el-input>
        </el-form-item>
        <el-form-item class="submit_item" style="margin-top: 45px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交， 去登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="forget_pwd form2" v-if="loginType == 1">
      <h4
        style="
          font-size: 24px;
          width: 1000px;
          margin: 0 auto;
          text-align: center;
        "
      >
        注册新用户
      </h4>
      <el-form
        style="margin-top: 20px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名：" prop="realname">
          <el-input v-model="ruleForm.realname" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idnum">
          <el-input
            v-model="ruleForm.idnum"
            onKeyUp="value=value.replace(/[\W]/g,'')"
            maxlength="18"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="ruleForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属地区：" prop="area_districts_id">
          <el-col :span="8">
            <el-select
              v-model="ruleForm.area_province_id"
              placeholder="请选择"
              @change="getcityData"
              size="small"
            >
              <el-option
                v-for="(item, index) in areaData1"
                :key="index"
                :label="item.area_name"
                :value="item.id"
              />
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="ruleForm.area_city_id"
              placeholder="请选择"
              @change="getdistrictsData"
              size="small"
            >
              <el-option
                v-for="(item, index) in areaData2"
                :key="index"
                :label="item.area_name"
                :value="item.id"
              />
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="ruleForm.area_districts_id"
              placeholder="请选择"
              size="small"
              @change="changedistricts"
            >
              <el-option
                v-for="(item, index) in areaData3"
                :key="index"
                :label="item.area_name"
                :value="item.id"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="单位:" prop="org_id">
          <el-select
            style="width: 100%"
            v-model="ruleForm.org_id"
            placeholder="请选择单位"
            size="small"
            filterable
          >
            <el-option
              v-for="(item, index) in restaurants"
              :key="index"
              :label="item.org_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="任教信息：" prop="grade_id">
          <el-col :span="8">
            <el-select
              v-model="ruleForm.stage_id"
              placeholder="请选择学段"
              @change="getstydy1"
              size="small"
            >
              <el-option
                v-for="(item, index) in studyData1"
                :key="index"
                :label="item.stage_name"
                :value="item.id"
              />
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="ruleForm.subject_id"
              placeholder="请选择学科"
              size="small"
            >
              <el-option
                v-for="(item, index) in studyData2"
                :key="index"
                :label="item.subject_name"
                :value="item.id"
              />
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="ruleForm.grade_id"
              placeholder="请选择年级"
              size="small"
            >
              <el-option
                v-for="(item, index) in studyData3"
                :key="index"
                :label="item.grade_name"
                :value="item.id"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="参与项目:" prop="evaluation_id">
          <el-select
            v-model="ruleForm.evaluation_id"
            placeholder="请选择参与项目"
            size="small"
          >
            <el-option
              v-for="(item, index) in evaluationList"
              :key="index"
              :label="item.project_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone_r">
          <el-input
            v-model="ruleForm.phone_r"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            maxlength="11"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="短信验证码：" prop="phone_code">
          <el-input
            v-model="ruleForm.phone_code"
            size="small"
            style="width: 200px"
          ></el-input>
          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="addCode"
            >发送短信验证码</el-button
          >
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input
            v-model="ruleForm.password"
            placeholder="请输入6-16位数字/字母组合成的密码（不支持特殊字符）"
            show-password
            size="small"
            @input="accountInput"
          />
        </el-form-item>
        <el-form-item show-password label="确认密码：" prop="repassword">
          <el-input
            v-model="ruleForm.repassword"
            show-password
            placeholder="请再次输入密码"
            size="small"
            @input="accountInput2"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="registerForm('ruleForm')"
            >提交注册</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  PhoneHasReg,
  PhoneHasReg2,
  GetVericationCode,
  UpdatePassword,
  registerLogin,
  getArea,
  getStage,
  getOrganization,
  getSubject,
  getGrade,
  getProject,
  getsendMobileRCode,
} from "../../api/login";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(
          new Error("请输入6-16位数字/字母组合成的密码（不支持特殊字符）")
        );
      } else {
        if (this.ruleForm.repassword !== "") {
          this.$refs.ruleForm.validateField("repassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // 验证手机号
    const rulesloginId = (rule, value, callback) => {
      if (!/^1[34578]\d{9}$/.test(value)) {
        callback("请输入正确的手机号");
      } else {
        callback();
      }
    };
    // 验证数字/字母/字符任意组合
    const validPassword = (rule, value, callback) => {
      //   let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
      let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入6-16位由数字/字母/字符组成的新密码"));
      } else {
        if (this.forgetForm.checkPwd !== "") {
          this.$refs.ruleForm.validateField("checkPwd");
        }
        callback();
      }
    };
    // 确认密码
    var againValidatePass = (rule, value, callback) => {
      if (value !== this.forgetForm.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 表单数据
      forgetForm: {},
      // 表单验证规则
      forgetRules: {
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: rulesloginId, trigger: ["change", "blur"] },
        ],
        newPwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: validPassword, trigger: "blur" },
        ],
        checkPwd: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur",
          },
          { validator: againValidatePass, trigger: "blur" },
        ],
      },
      countDownNumber: 60, // 倒计时时间
      codeText: "发送验证码",
      countDownType: true, // 如果已经发送验证码时，置为false，让其不可再次发送验证码，60秒后可再次发送
      is_reg: false, // false表未注册
      noRegText: "该账号未注册", // 手机号未注册提示信息
      loginType: localStorage.getItem("loginType"),
      areaData1: [],
      areaData2: [],
      areaData3: [],
      restaurants: [],
      studyData1: [],
      studyData2: [],
      studyData3: [],
      evaluationList: [],
      ruleForm: {
        realname: "",
        idnum: "",
        sex: "",
        area_province_id: "",
        area_city_id: "",
        area_districts_id: "",
        org_id: "",
        stage_id: "",
        subject_id: "",
        grade_id: "",
        evaluation_id: "",
        phone_r: "",
        phone_code: "",
        password: "",
        repassword: "",
      },
      rules: {
        realname: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          { min: 2, max: 5, message: "请输入真实姓名", trigger: "blur" },
        ],
        idnum: [
          { required: true, message: "请输入您的身份证号", trigger: "blur" },
          { min: 18, max: 18, message: "请输入正确身份证号", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        area_districts_id: [
          { required: true, message: "请选择所属地区", trigger: "change" },
        ],
        org_id: [{ required: true, message: "请选择单位", trigger: "blur" }],
        grade_id: [
          { required: true, message: "请选择任教信息", trigger: "change" },
        ],
        evaluation_id: [
          { required: true, message: "请选择参与项目", trigger: "change" },
        ],
        phone_r: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确手机号", trigger: "blur" },
        ],
        phone_code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "请输入6-16位数字/字母组合成的密码（不支持特殊字符）",
            trigger: "blur",
          },
        ],
        repassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.loginType == 1) {
      this.getZiDian();
    }
  },
  methods: {
    accountInput(val) {
      //账号的实时输入
      let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
        len = val.length,
        str = "";
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i];
        }
      }
      this.ruleForm.password = str;
    },
    accountInput2(val) {
      //账号的实时输入
      let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
        len = val.length,
        str = "";
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i];
        }
      }
      this.ruleForm.repassword = str;
    },
    accountInputs1(val) {
      //账号的实时输入
      let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
        len = val.length,
        str = "";
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i];
        }
      }
      this.forgetForm.newPwd = str;
    },
    accountInputs2(val) {
      //账号的实时输入
      let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
        len = val.length,
        str = "";
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i];
        }
      }
      this.forgetForm.checkPwd = str;
    },
    // 获取验证码倒计时
    timeDown() {
      let countDownSetInterval = setInterval(() => {
        this.countDownNumber = this.countDownNumber - 1;
        this.codeText = "倒计时" + this.countDownNumber + " 秒";
        this.countDownType = false;
        if (this.countDownNumber == 0) {
          this.countDownType = true;
          this.codeText = "重新发送";
          this.countDownNumber = 60;
          clearInterval(countDownSetInterval);
        }
      }, 1000);
    },
    // 发送验证码
    sendCode() {
      if (this.countDownType) {
        PhoneHasReg({
          phone: this.forgetForm.phone,
        }).then((res) => {
          if (res.data.is_reg !== 0) {
            //获取验证码
            GetVericationCode({
              phone: this.forgetForm.phone,
            }).then((res) => {
              // 倒计时
              this.$message.success("验证码已发送");
              this.timeDown();
            });
          } else {
            this.$message.success("该手机号未注册");
          }
        });
      }
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          UpdatePassword({
            phone: this.forgetForm.phone,
            code: this.forgetForm.verificationCode,
            password: this.forgetForm.newPwd,
            repassword: this.forgetForm.checkPwd,
          }).then((res) => {
            this.$message({
              showClose: true,
              message: "修改密码成功",
              type: "success",
            });

            // 跳到登录
            setTimeout(() => {
              this.$emit("triggerLogin");
            }, 1000);
          });
        } else {
          return false;
        }
      });
    },
    // 注册----------------------------
    registerForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let phoneTest = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/; //校验密码6-18位
          if (!phoneTest.test(this.ruleForm.password)) {
            this.$message.error(
              "请输入6-16位数字/字母组合成的密码（不支持特殊字符）"
            );
            return;
          }
          registerLogin(this.ruleForm).then((res) => {
            this.$message.success("恭喜，注册成功！");
            let webUserInfo = res.data;
            localStorage.setItem("webUserInfo", JSON.stringify(webUserInfo));
            setTimeout(() => {
              // 重新加载页面
              location.reload();
            }, 800);
          });
        } else {
          return false;
        }
      });
    },
    // 发送验证码
    addCode() {
      if (this.ruleForm.phone_r.length == 11) {
        PhoneHasReg2({ phone2: this.ruleForm.phone_r }).then((res) => {
          if (res.data.is_reg == 0) {
            getsendMobileRCode({ phone_r: this.ruleForm.phone_r }).then(
              (res) => {
                this.$message.success("验证码发送成功");
              }
            );
          } else {
            this.$message.error("该手机号已经注册，请直接登陆");
          }
        });
      } else {
        this.$message.error("请输入您的手机号");
      }
    },
    // 获取市级列表
    getcityData(val) {
      this.ruleForm.area_city_id = "";
      this.ruleForm.area_districts_id = "";
      getArea({ pid: val }).then((res) => {
        this.areaData3 = [];
        this.areaData2 = res.data;
      });
    },
    // 获取区级列表
    getdistrictsData(val) {
      this.ruleForm.area_districts_id = "";
      getArea({ pid: val }).then((res) => {
        this.areaData3 = res.data;
      });
    },
    changedistricts(val) {
      getOrganization({ area_districts_id: val, page: 1, limit: 999 }).then(
        (res) => {
          this.ruleForm.org_id = "";
          this.restaurants = res.data;
        }
      );
    },
    getstydy1(val) {
      this.ruleForm.subject_id = "";
      this.ruleForm.grade_id = "";
      getSubject({ id: val }).then((res) => {
        this.studyData2 = res.data;
      });
      getGrade({ id: val }).then((res) => {
        this.studyData3 = res.data;
      });
    },
    // 获取字典
    getZiDian() {
      getArea({ pid: 0 }).then((res) => {
        this.areaData1 = res.data;
      });
      getStage().then((res) => {
        this.studyData1 = res.data;
      });
      getProject().then((res) => {
        this.evaluationList = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.forget_page {
  background-color: #f7f7f7;
  padding-top: 20px;
  // height: 700px;
  .forget_pwd {
    position: relative;
    width: 1300px;
    height: 700px;
    background-color: #fff;
    margin: 0 auto;
    h3 {
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      width: 1000px;
      height: 122px;
      line-height: 135px;
      margin: 0 auto;
      border-bottom: 1px dotted #ececec;
    }
    // 表单
    .forger_form {
      position: absolute;
      left: 50%;
      top: 53%;
      transform: translate(-50%, -50%);
      .phoneClass {
        /deep/ .el-form-item__content {
          display: flex;
        }
        .noreg {
          color: #ff0607;
          height: 40px;
          padding-top: 8px;
          img {
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
      /*修改提示信息字体大小*/
      /deep/ .el-form-item__error {
        font-size: 14px;
      }
      /deep/ .el-form-item {
        margin-bottom: 26px;
        .el-form-item__label {
          padding-top: 4px;
          font-weight: normal;
        }
        /deep/ .el-input__inner {
          width: 439px;
          height: 46px;
          // 修改placeholder样式
          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            font-size: 16px;
            color: #9a9ea5;
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ 适配火狐 */
            font-size: 16px;
            color: #9a9ea5;
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10+  适配ie*/
            font-size: 16px;
            color: #9a9ea5;
          }
        }
        // 去掉number类型尾部上下小箭头start
        /deep/ .el-input__inner::-webkit-outer-spin-button,
        /deep/ .el-input__inner::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          -o-appearance: none !important;
          -ms-appearance: none !important;
          appearance: none !important;
          margin: 0;
        }
        /deep/ .el-input__inner[type="number"] {
          -webkit-appearance: textfield;
          -moz-appearance: textfield;
          -o-appearance: textfield;
          -ms-appearance: textfield;
          appearance: textfield;
        }
        // 去掉number类型尾部上下小箭头end
        /deep/ .el-form-item__label {
          padding-right: 20px;
          font-size: 16px;
          color: #333;
        }
      }
      .v_code {
        .el-button {
          width: 153px;
          height: 45px;
        }
      }
      .submit_item {
        .el-button {
          width: 230px;
          height: 45px;
        }
        .el-button--primary {
          background-color: #fa8c15;
          border-color: #fff;
        }
      }
      /deep/ .el-form-item__content {
        display: flex;
      }
    }
  }
  .forget_pwd
    .forger_form
    .el-form-item[data-v-63ddf6e4]
    .code
    /deep/
    .el-input__inner {
    width: 284px;
  }
}
.forget_page
  .forget_pwd
  .forger_form[data-v-63ddf6e4]
  .phoneClass
  /deep/
  .el-form-item__content {
  display: block;
  //   display: flex;
}
/deep/.demo-ruleForm {
  width: 50%;
  margin: 0 auto;
}
.form2 {
  /deep/.el-form-item {
    margin-bottom: 10px;
  }
  /deep/.el-form-item__error {
    padding-top: 0;
  }
}
</style>
